module.exports = __webpack_public_path__ + "img/Majung_Cannibal.34920ae1.jpg";